module.exports = __webpack_public_path__ + "static/media/Zoroark_gaussian2.9a4865c2.png";